import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { Grid, IconButton, Stack } from '@mui/material';

import { IcDeleteTrash } from '@/assets/images';
import { RenderFormField } from '@/components';
import { Button } from '@/components/TailwindComponents';
import { colors } from '@/theme/variables';

export const EmailsForm = ({ disabled = false }: { disabled?: boolean }) => {
  const { control, setValue, watch } = useFormContext();
  const { remove, append, fields, replace } = useFieldArray({
    control,
    name: 'emails',
  });

  const existingEmails = watch('emails') || [];

  useEffect(() => {
    // Convert string emails to object format if needed
    if (existingEmails.length > 0 && typeof existingEmails[0] === 'string') {
      replace(
        existingEmails.map((email: string) => ({
          email: email.toLowerCase(),
        })),
      );
    }
  }, [existingEmails, replace]);

  const handleAddEmail = () => {
    append({ email: '' });
  };

  const handleRemoveEmail = (index: number) => {
    if (fields.length === 1) {
      setValue(`emails.${index}.email`, '');
    } else {
      remove(index);
    }
  };

  const handleEmailChange = (index: number, value: string) => {
    setValue(`emails.${index}.email`, value.toLowerCase());
  };

  return (
    <Stack my={2}>
      {fields.map((emailField, index: number) => {
        const emailValue = watch(`emails.${index}.email`) || '';

        return (
          <Grid
            container
            columnSpacing={2}
            key={`row-${emailField.id}-${index}`}
          >
            <Grid xs={10} item>
              <RenderFormField
                label="Email Address"
                name={`emails.${index}.email`}
                type="email"
                disabled={disabled}
                rules={
                  emailValue.trim() !== ''
                    ? {
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: 'Invalid email format',
                        },
                      }
                    : {}
                }
                onChange={(e: any) => handleEmailChange(index, e.target.value)}
                inputProps={{
                  style: { textTransform: 'lowercase' },
                }}
              />
            </Grid>
            <Grid style={{ display: 'flex' }} xs={2} item>
              <IconButton
                onClick={() => handleRemoveEmail(index)}
                disabled={disabled}
                sx={{ color: colors.error.main, mt: 2, alignSelf: 'center' }}
              >
                <IcDeleteTrash />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}
      <Button
        color="error"
        type="button"
        size="sm"
        variant="secondary"
        className="w-fit text-sm"
        onClick={handleAddEmail}
        disabled={disabled}
      >
        + Add Email
      </Button>
    </Stack>
  );
};
